import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    validateCustSrc: "/pb/primarycontact",
    appHeight: 0,
    spinnerState: false,
    langTexts: {},
    langTextCode: null
  },
  mutations: {
    setSpinnerState(state, newState) {
      state.spinnerState = newState;
    },
    setLangTexts(state, newState) {
      state.langTexts = newState;
    },
    setLangTextCode(state, newState) {
      state.langTextCode = newState;
    }
  },
  actions: {
    getLangTexts({ commit, state }) {
      if (_.isEmpty(state.langTexts) || state.langTextCode !== 200) {
        axios.get(state.validateCustSrc + '/langtext').then(function(resp) {
          commit('setLangTextCode', resp.status);
          commit('setLangTexts', resp.data);
        }).catch(function(e){
          commit('setLangTextCode', (e.response?.status || 404));
          commit('setLangTexts', {});
        })
      }
    }
  },
  modules: {
  }
})
